/**
 * Auth0 social connection names — must match Authentication → Social in Auth0.
 * Override via VITE_AUTH0_GOOGLE_CONNECTION if your tenant uses a custom name.
 */
export const AUTH0_CONNECTIONS = {
  google:
    import.meta.env.VITE_AUTH0_GOOGLE_CONNECTION?.trim() || 'google-oauth2',
} as const;

export type Auth0SocialConnection =
  (typeof AUTH0_CONNECTIONS)[keyof typeof AUTH0_CONNECTIONS];
